module.exports = __webpack_public_path__ + "static/img/image_03@2x.3f9d201.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/KtbTrio/image_03@2x.png
// module id = tJqK
// module chunks = 70